"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_FILTRATION = exports.SET_PACKAGE_THEME = exports.SET_DEBUG_MODE_STATUS = exports.ACTIVE_CAMERA_PERSPECTIVE = void 0;
var _constants = require("../../utils/constants");
const SET_PACKAGE_THEME = exports.SET_PACKAGE_THEME = "SET_PACKAGE_THEME".concat(_constants.packagePrefix);
const SET_DEBUG_MODE_STATUS = exports.SET_DEBUG_MODE_STATUS = "SET_DEBUG_MODE_STATUS_WEBGL".concat(_constants.packagePrefix);
const UPDATE_FILTRATION = exports.UPDATE_FILTRATION = "UPDATE_FILTRATION_WEBGL".concat(_constants.packagePrefix);
const ACTIVE_CAMERA_PERSPECTIVE = exports.ACTIVE_CAMERA_PERSPECTIVE = "ACTIVE_CAMERA_PERSPECTIVE_WEBGL".concat(_constants.packagePrefix);